import { UPDATE_REQUIREMENT } from '../../endpoints';
import { IRequirement } from '../../types/brand';
import makeAuthenticatedRequest from '../base-api';

interface UpdateRequirementResponse {
  success: boolean;
  message?: string;
  requirement?: IRequirement;
}

const updateRequirementApi = async (
  payload: {
    _id: string;
    agents?: string[];
    status?: 'fulfilled' | 'sourced' | 'active' | 'postponed' | 'dropped' | 'reopened';
  }
): Promise<UpdateRequirementResponse> => {
  try {
    const response = await makeAuthenticatedRequest(UPDATE_REQUIREMENT, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();

    if (!response.ok) {
      if (result.message) {
        throw new Error(result.message);
      } else {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    }

    return result;
  } catch (error) {
    console.error('Update brand failed:', error);
    throw error;
  }
};

export { updateRequirementApi, type UpdateRequirementResponse };